export default __webpack_public_path__ + "static/media/create-team-third.d0303730.jpg";